import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetCommon() {
  const URL = endpoints.common.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      common: data?.data || [],
      commonLoading: isLoading,
      commonError: error,
      commonValidating: isValidating,
      commonEmpty: !isLoading && !data?.data.length,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ---------------------------------------------------------------------

export function useGetCommonWithFilter(filter) {
  let URL;
  if (filter) {
    URL = endpoints.common.filterList(filter);
  } else {
    URL = endpoints.common.list;
  }

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher);

  const refreshFilterCommon = () => {
    // Use the `mutate` function to trigger a revalidation
    mutate();
  };

  return {
    filteredCommon: data || [],
    filteredCommonLoading: isLoading,
    filteredCommonError: error,
    filteredCommonValidating: isValidating,
    filteredCommonEmpty: !isLoading && !data?.length,
    refreshFilterCommon, // Include the refresh function separately
  };
}
